// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"854":"cb2de738","890":"c6ea32ae"}[chunkId] + ".chunk.js";
};